module.exports = "/fonts/developer-logotype-l-381975363a8b14f801947c3e000bcf9b.svg";